let startTime;

const startTracking = () => {
  if (!startTime) {
    startTime = new Date();
  }
}

const getElapsedTime = () => {
  const now = new Date();
  const timeElapsed = now - startTime;
  return timeElapsed;
}


const consoleTimeTrack = (message, callerInfo = {}) => {
  if (process.env.NODE_ENV === 'development') {
    startTracking();
    const timeElapsed = getElapsedTime();

    if (message) {
      const milliseconds = (timeElapsed % 1000).toFixed(3); // Milliseconds with 3 decimal places
      const seconds = Math.floor((timeElapsed / 1000) % 60); // Convert to seconds
      const minutes = Math.floor((timeElapsed / (1000 * 60)) % 60); // Convert to minutes
      const prettyTime = `[${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${milliseconds.padStart(6, '0')}]`;

      const callerInfoStr = callerInfo.fileName || callerInfo.methodName 
      ? `- [${callerInfo.fileName || ''}]${callerInfo.methodName ? `-> ${callerInfo.methodName}` : ''}` 
      : '';

      console.log(`\x1b[33m%s\x1b[0m \x1b[32m%s\x1b[0m`, `⏱ ${prettyTime}`, `${callerInfoStr}`, message);
    }
    return timeElapsed;
  } else {
    return 0;
  }
}

export { consoleTimeTrack }